'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdCloudOff = function MdCloudOff(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm12.9 16.6h-2.9c-3.7 0-6.6 3.1-6.6 6.8s2.9 6.6 6.6 6.6h16.3z m-7.9-7.8l2.1-2.2 27.9 27.9-2.1 2.1-3.4-3.2h-19.5c-5.5 0-10-4.5-10-10 0-5.4 4.3-9.8 9.6-10z m27.3 7.9c4.3 0.3 7.7 3.9 7.7 8.3 0 2.8-1.4 5.3-3.5 6.8l-2.4-2.4c1.5-0.9 2.5-2.5 2.5-4.4 0-2.7-2.2-5-5-5h-2.5v-0.9c0-5-4-9.1-9.1-9.1-1.6 0-3 0.3-4.2 1l-2.5-2.4c1.9-1.3 4.2-2 6.7-2 6.1 0 11.1 4.3 12.3 10.1z' })
        )
    );
};

exports.default = MdCloudOff;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/cloud-off.js
// module id = 2940
// module chunks = 0